import { Stack, Typography } from '@mui/material';
import { isEqual, omit } from 'lodash';
import { memo } from 'react';
import { CustomTooltip } from 'src/components/tooltip/CustomTooltip';

import { ResourceSelectorSidebarItemProps } from './ResourceSelectorSidebarItem.interface';
import {
  ResourceSelectorSidebarItemContainer,
  ResourceSelectorSidebarItemPreview,
  ResourceSelectorSidebarItemTitle,
} from './ResourceSelectorSidebarItem.styled';

export const ResourceSelectorSidebarItem = memo(
  (props: ResourceSelectorSidebarItemProps) => {
    return (
      <ResourceSelectorSidebarItemContainer
        onClick={props.onClick}
        $isSelected={props.isSelected}>
        {props.icon && (
          <Stack
            sx={{
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
            }}>
            {props.icon}
          </Stack>
        )}

        {props.src && (
          <ResourceSelectorSidebarItemPreview
            component="img"
            src={props.src}
            loading="lazy"
            sx={{ height: '100%', width: '100%' }}
          />
        )}

        <ResourceSelectorSidebarItemTitle
          position="below"
          title={
            <CustomTooltip
              width={500}
              placement="bottom"
              title={props.fileName}
              overflowLineNumber={1}>
              <Typography variant="body2">{props.fileName}</Typography>
            </CustomTooltip>
          }
        />
      </ResourceSelectorSidebarItemContainer>
    );
  },
  (prevProps, nextProps) => {
    const prevRest = omit(prevProps, ['onClick']);
    const nextRest = omit(nextProps, ['onClick']);

    return isEqual(prevRest, nextRest);
  },
);
